import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export interface DriftPoint {
  audit_id: string;
  completed_at: string;
  overall_score: number;
  dimensions: Record<string, number>;
}

export interface DriftEvent {
  from_audit_id: string;
  to_audit_id: string;
  occurred_at: string;
  dimension_id: string;
  dimension_name: string;
  before: number;
  after: number;
  delta: number;
}

export interface DriftTimelineResponse {
  points: DriftPoint[];
  events: DriftEvent[];
  pr_summary_30d: {
    prs_reviewed: number;
    prs_skipped: number;
    with_findings: number;
  };
}

export function useDriftTimeline() {
  return useQuery({
    queryKey: ['drift', 'timeline'],
    queryFn: () => api<DriftTimelineResponse>('/api/drift/timeline'),
    staleTime: 30_000,
  });
}
